import { render } from "./OratorPrepView.vue?vue&type=template&id=3e161612&scoped=true"
import script from "./OratorPrepView.vue?vue&type=script&lang=js"
export * from "./OratorPrepView.vue?vue&type=script&lang=js"

import "./OratorPrepView.vue?vue&type=style&index=0&id=3e161612&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e161612"]])

export default __exports__